export const messages = {
  'shared-link.footer.link.install': 'Try {brandName} for free',
  'shared-link.footer.link.mobile': '{brandName} for Mobile',
  'shared-link.footer.link.android': 'Android',
  'shared-link.footer.link.ios': 'iOS',
  'shared-link.password-dialog-box.title': 'Protected data',
  'shared-link.password-dialog-box.message': 'Please specify the password to access the shared data',
  'shared-link.password-dialog-box.hint.password': 'Password',
  'shared-link.password-dialog-box.message.invalid-password': 'The password is incorrect',
  'shared-link.form.button.open': 'Open',
  'shared-link.page-not-found.title': 'Page not found',
  'shared-link.page-not-found.message.main': 'The page you were looking for was not found.',
  'shared-link.page-not-found.message.description': 'The link may be outdated, or you may have typed the address incorrectly.',
  'shared-link.page-not-found.message.error': 'Error code: 404',
  'shared-link.restore-file.label.size': 'Size',
  'shared-link.restore-file.button.restore': 'Download',
  'shared-link.links-table.column.name': 'Name',
  'shared-link.links-table.column.size': 'Size',
  'shared-link.links-table.action.restore': 'Download',
  'shared-link.links-table.action.restore-all': 'Download all',
  'shared-link.side-bar.selected.title:plural': '{count} item selected | {count} items selected',
  'shared-link.links-table.label.size': 'Size',
  'shared-link.links-table.message.empty-folder': 'This folder is empty'
};
